  const accordionHeaders = document.querySelectorAll('.accordion-header');
  const checkboxes = document.querySelectorAll('input[type="checkbox"]');
  const findRecipesButton = document.getElementById('findRecipes');

  accordionHeaders.forEach(header => {
    header.addEventListener('click', () => {
      const accordionContent = header.nextElementSibling;
      const arrow = header.querySelector('.accordion-arrow');
      
      accordionContent.style.display = accordionContent.style.display === 'none' ? 'block' : 'none';
      arrow.style.transform = accordionContent.style.display === 'none' ? 'rotate(-45deg)' : 'rotate(135deg)';
    });
  });

  findRecipesButton.addEventListener('click', () => {
    const selectedFilters = Array.from(checkboxes)
      .filter(checkbox => checkbox.checked)
      .map(checkbox => checkbox.value);

     

    const blogs = document.querySelectorAll(".recipes-box");
    blogs.forEach(blog => {
        if (!selectedFilters.length) {
          blog.style.display = "block"; 
          return;
        }
        const blogText = blog.textContent.toLowerCase(); 
        if (hasKeyword(blogText, selectedFilters)) {
            blog.style.display = "block"; 
        } else {
            blog.style.display = "none"; 
        }
    });
  });

function hasKeyword(text,  keywords) {
    return keywords.some(keyword => text.includes(keyword));
}


const taber = document.querySelectorAll('.tabs__btner');
    const tabsContent = document.querySelectorAll('.tabs__bodyer');

    if (tabsContent.length > 0 || tabs.length > 0) {

        function hideTabContent() {
            tabsContent.forEach(item => {
                item.classList.remove('active');
            });

            taber.forEach(item => {
                item.classList.remove('active');
            });
        }

        function showTabContent(i = 0) {
            tabsContent[i].classList.add('active');
            taber[i].classList.add('active');
        }

        // hideTabContent();
        // showTabContent();

        taber.forEach((tab, index) => {
            tab.addEventListener('click', () => {
                hideTabContent();
                showTabContent(index);
            });
        });
    }